import { useMemo, useState } from 'react';
import { extent } from 'd3-array';

import { getInteractionData, getTrend } from '../utils';

type Args = {
  portfolioTimeseries: [Date, number][];
  benchmarkTimeseries: [Date, number][];
};

export const useChartData = ({
  portfolioTimeseries,
  benchmarkTimeseries,
}: Args) => {
  const [interactionIndex, setInteractionIndex] = useState(0);

  const { xDomain, yDomain } = useMemo(() => {
    const combinedData = [...portfolioTimeseries, ...benchmarkTimeseries];

    const xExtent = extent(combinedData, (d) => d[0].getTime());
    const yExtent = extent(combinedData, (d) => d[1]);

    return {
      xDomain: [xExtent[0] || 0, xExtent[1] || 0],
      yDomain: [yExtent[0] || 0, yExtent[1] || 0],
    };
  }, [portfolioTimeseries, benchmarkTimeseries]);

  const interactionPoints = useMemo(
    () => getInteractionData(benchmarkTimeseries, portfolioTimeseries),
    [benchmarkTimeseries, portfolioTimeseries]
  );

  const selectedDate = portfolioTimeseries[interactionIndex]?.[0] || null;
  const metricsForSelectedDate = selectedDate
    ? interactionPoints[selectedDate.toISOString().slice(0, 10)]
    : null;
  const benchmarkMetric = metricsForSelectedDate?.benchmark || null;
  const portfolioMetric = metricsForSelectedDate?.portfolio || null;
  const portfolioTrend = getTrend(portfolioTimeseries);

  return {
    xDomain,
    yDomain,
    interactionIndex,
    setInteractionIndex,
    interactionPoints,
    benchmarkMetric,
    portfolioMetric,
    portfolioTrend,
  };
};
